import React, { useState } from 'react'
import { useSignup } from '../hooks/useSignup'
import Logo from '../images/logo.png'


const Signup = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { signup, isLoading, error } = useSignup()

  const handleSubmit = async (e) => {
    e.preventDefault()
    await signup(name, email, password)
  }

  return (
    <div className='w-full h-screen bg-white'>
      <form className='mx-auto flex items-center w-9/12  rounded-2xl p-10'
        onSubmit={handleSubmit}>
        <div className="w-full">
          <center>
            <img className="mb-3 w-20" alt='strathmore connect logo' src={Logo}></img>
          </center>
          <h3 className='text-3xl font-bold'><center>Sign up</center></h3>
          <div className='mt-3'>
            <label className='form-label'>Name</label>
            <input
              type="text"
              onChange={(e) => { setName(e.target.value) }}
              value={name}
              name="name"
              placeholder='name'
              autoComplete='on'
              className="block w-full p-2 text-md text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            />
          </div>
          <div className='mt-3'>
            <label className='form-label'>Email</label>
            <input
              type="email"
              onChange={(e) => { setEmail(e.target.value) }}
              value={email}
              name="email"
              placeholder='email'
              autoComplete='off'
              className="block w-full p-2 text-md text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            />
          </div>

          <div className='mt-3'>
            <label className='form-label'>Password</label>

            <input
              type="password"
              onChange={(e) => { setPassword(e.target.value) }}
              value={password}
              name="password"
              placeholder='password'
              autoComplete='off'
              className="block w-full p-2 text-md text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            />
          </div>
          {!isLoading ?
            <button disabled={isLoading}
              className='w-full mt-5 items-center px-3 py-2 text-sm font-medium text-center
          text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none
          focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700
           dark:focus:ring-blue-800'>Sign up</button> :

            <button disabled type="button" class="w-full items-center  mt-6 px-3 py-2 text-sm font-medium text-center
           text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none
           focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700
            dark:focus:ring-blue-800">
              <svg aria-hidden="true" role="status" class="inline w-4 h-4 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
              </svg>
              Loading...
            </button>}
          {error && <div
            className='w-full  mx-auto mt-4 text-center bg-red-200 border-2 border-red-300 py-1.5 px-1.5 text-red-900 rounded-xl m-2'
          >{error}</div>}
        </div>
      </form>
    </div>
  )
}

export default Signup